import React from 'react';

class Image extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
  }

  download = () => {
    var image = this.canvasRef.current
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');
    document.write(`<img src="${image}"/>`);
  };

  render() {
    return (
      <canvas
        ref={this.canvasRef}
        onClick={this.download}
        style={{ width: '100px', height: '100px', backgroundColor: 'red' }}
      >
        image
      </canvas>
    );
  }
}

export default Image;
